<template>
  <core-dialog
    :visible="visible"
    @update:visible="close"
    :title="$t('create_claim')"
    @close="close"
    :use_default_breakpoints="false"
    :lg_width="40"
    :xl_width="40"
    :md_width="50"
    :xs_width="90"
    :destroy-on-close="true"
    :close-on-click-modal="false"
  >
  <div id="return_shipments_dialog__container" class=" w-full h-auto max-h-screen">

  <div class="w-full px-16 py-6" v-if="!shipment" >
    <div class="w-full flex gap-4">
      <core-input
        :label="$t('package_number')"
        v-model="package_number"
      />
      <core-button
        type="coolrunner"
        @click="getPackage()"
        class="mt-2"
        :disabled="checkPackageNumber"
        >{{ $t("get") + ' ' + $tc('package', 1).toLowerCase() }}
      </core-button>
    </div>
    <p v-if="packageError" class="text-red-600 mt-5 w-full text-center">{{ $t('no_package') }}</p>
    <p @click="goToShipment()" v-if="ticketExistsId" class="mt-5 w-full text-center cursor-pointer">{{ $t("go_to_entity", {entity: $tc("shipment", 1).toLowerCase() }) }}</p>
  </div>

  <div v-if="shipment" class="px-16 py-6 w-full h-auto">
    <div class="rounded-md grid grid-cols-3 gap-[1px]">
      <div class="bg-gray-50 col-span-2 py-3 px-2 rounded-tl-md">
        <p class="text-[#737C89] text-sm ">{{$t('package_number')}}</p>
        <p>{{ shipment.package_number }}</p>
      </div>
      <div class="bg-gray-50 col-span-1 py-3 px-2 rounded-tr-md">
        <p class="text-[#737C89] text-sm break-normal">{{$t('reference')}}</p>
        <p>{{ shipment.reference }}</p>
      </div>
      <div class="bg-gray-50 col-span-3 flex py-3 px-2 rounded-b-md">
        <p class="text-[#737C89] text-sm pr-2 border-r border-[#B5B9BD] break-normal">{{ $t("sent_with_entity", { entity: $t(shipment.carrier)}) }}</p>
        <p v-if="shipment.order_lines" class="text-[#737C89] text-sm pr-2 pl-2 border-r border-[#B5B9BD] break-normal">{{'Indeholder ' + getNumberOfItems(shipment.order_lines) + ' produkt(er)'}}</p>
        <p v-if="shipment.latest_tracking_event" class="text-[#737C89] text-sm pr-2 pl-2 break-normal">{{$t('status')}}: {{shipment.latest_tracking_event.event_code}}</p>
      </div>
    </div>
    <div v-if="deadline" class="text-red-600 text-sm mt-5 w-full text-center break-normal" v-html="$t('deadline_warning')"></div>
    <div class="mt-3 rounded-md">
      <div class="custom-select" :tabindex="tabindex" @blur="open = false">
        <div class="selected" :class="{ open: open }" @click="open = !open">
          {{ selectedType.name }}
        </div>
        <div class="items overflow-visible" :class="{ selectHide: !open }">
          <div class="py-2" v-for="(option, i) of options" :key="i" @click="selectType(option)">
            <p class="text-[#273F52] text-sm font-medium">{{ option.name }}</p>
            <ul v-if="option.description" class="list-disc list-inside leading-4 ml-2 text-[#273F52] break-normal">
              <li class="m-0 leading-4 text-xs text-[#273F52] break-normal">{{ option.description }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div v-if="inputs.length !== 0">
      <p class="mt-5 text-[#273F52]">{{ $t('documentation') }}</p>
      <div v-for="input, index in inputs" :key="input.id">
        <div class="relative" v-if="input.type == 'number' && claim.attributes.length !== 0">
          <core-number class="mt-3 w-full items-stretch max-w-full" v-model="claim.attributes[index].value" :label="input.name" />
          <div class="flex-col cursor-pointer flex has-tooltip absolute top-0 -left-6">
            <svg class="mt-0.5 ml-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.75 11.25C8.75 11.3983 8.70602 11.5433 8.6236 11.6667C8.54119 11.79 8.42406 11.8861 8.28701 11.9429C8.14997 11.9997 7.99917 12.0145 7.85368 11.9856C7.7082 11.9566 7.57456 11.8852 7.46967 11.7803C7.36478 11.6754 7.29335 11.5418 7.26441 11.3963C7.23548 11.2508 7.25033 11.1 7.30709 10.963C7.36386 10.8259 7.45999 10.7088 7.58333 10.6264C7.70666 10.544 7.85167 10.5 8 10.5C8.19892 10.5 8.38968 10.579 8.53033 10.7197C8.67098 10.8603 8.75 11.0511 8.75 11.25ZM8 4.5C6.62125 4.5 5.5 5.50938 5.5 6.75V7C5.5 7.13261 5.55268 7.25979 5.64645 7.35355C5.74022 7.44732 5.86739 7.5 6 7.5C6.13261 7.5 6.25979 7.44732 6.35356 7.35355C6.44732 7.25979 6.5 7.13261 6.5 7V6.75C6.5 6.0625 7.17313 5.5 8 5.5C8.82688 5.5 9.5 6.0625 9.5 6.75C9.5 7.4375 8.82688 8 8 8C7.86739 8 7.74022 8.05268 7.64645 8.14645C7.55268 8.24021 7.5 8.36739 7.5 8.5V9C7.5 9.13261 7.55268 9.25979 7.64645 9.35355C7.74022 9.44732 7.86739 9.5 8 9.5C8.13261 9.5 8.25979 9.44732 8.35356 9.35355C8.44732 9.25979 8.5 9.13261 8.5 9V8.955C9.64 8.74563 10.5 7.83625 10.5 6.75C10.5 5.50938 9.37875 4.5 8 4.5ZM14.5 8C14.5 9.28558 14.1188 10.5423 13.4046 11.6112C12.6903 12.6801 11.6752 13.5132 10.4874 14.0052C9.29973 14.4972 7.99279 14.6259 6.73192 14.3751C5.47104 14.1243 4.31285 13.5052 3.40381 12.5962C2.49477 11.6872 1.8757 10.529 1.6249 9.26809C1.37409 8.00721 1.50282 6.70028 1.99479 5.51256C2.48676 4.32484 3.31988 3.30968 4.3888 2.59545C5.45772 1.88122 6.71442 1.5 8 1.5C9.72335 1.50182 11.3756 2.18722 12.5942 3.40582C13.8128 4.62441 14.4982 6.27665 14.5 8ZM13.5 8C13.5 6.9122 13.1774 5.84883 12.5731 4.94436C11.9687 4.03989 11.1098 3.33494 10.1048 2.91866C9.09977 2.50238 7.9939 2.39346 6.92701 2.60568C5.86011 2.8179 4.8801 3.34172 4.11092 4.11091C3.34173 4.8801 2.8179 5.86011 2.60568 6.927C2.39347 7.9939 2.50238 9.09977 2.91867 10.1048C3.33495 11.1098 4.0399 11.9687 4.94437 12.5731C5.84884 13.1774 6.91221 13.5 8 13.5C9.45819 13.4983 10.8562 12.9184 11.8873 11.8873C12.9184 10.8562 13.4983 9.45818 13.5 8Z" fill="#4B4F54" style="fill:#4B4F54;fill:color(display-p3 0.2941 0.3098 0.3294);fill-opacity:1;"/>
            </svg>
            <p
              class="tooltip min-w-[200px] bg-gray-50 shadow-md rounded-md p-2 text-left font-default text-sm break-normal"
              style=""
              >{{ input.description }}
            </p>
          </div>
        </div>
        <div class="relative" v-if="input.type == 'textarea' && claim.attributes.length !== 0">
          <core-input
            class="mt-3 w-full items-stretch max-w-full"
            inputType="textarea"
            placeholder=""
            :label="input.name"
            @change="val => claim.attributes[index].value = val"
          />
          <div class="flex-col cursor-pointer flex has-tooltip absolute top-0 -left-6">
            <svg class="mt-0.5 ml-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.75 11.25C8.75 11.3983 8.70602 11.5433 8.6236 11.6667C8.54119 11.79 8.42406 11.8861 8.28701 11.9429C8.14997 11.9997 7.99917 12.0145 7.85368 11.9856C7.7082 11.9566 7.57456 11.8852 7.46967 11.7803C7.36478 11.6754 7.29335 11.5418 7.26441 11.3963C7.23548 11.2508 7.25033 11.1 7.30709 10.963C7.36386 10.8259 7.45999 10.7088 7.58333 10.6264C7.70666 10.544 7.85167 10.5 8 10.5C8.19892 10.5 8.38968 10.579 8.53033 10.7197C8.67098 10.8603 8.75 11.0511 8.75 11.25ZM8 4.5C6.62125 4.5 5.5 5.50938 5.5 6.75V7C5.5 7.13261 5.55268 7.25979 5.64645 7.35355C5.74022 7.44732 5.86739 7.5 6 7.5C6.13261 7.5 6.25979 7.44732 6.35356 7.35355C6.44732 7.25979 6.5 7.13261 6.5 7V6.75C6.5 6.0625 7.17313 5.5 8 5.5C8.82688 5.5 9.5 6.0625 9.5 6.75C9.5 7.4375 8.82688 8 8 8C7.86739 8 7.74022 8.05268 7.64645 8.14645C7.55268 8.24021 7.5 8.36739 7.5 8.5V9C7.5 9.13261 7.55268 9.25979 7.64645 9.35355C7.74022 9.44732 7.86739 9.5 8 9.5C8.13261 9.5 8.25979 9.44732 8.35356 9.35355C8.44732 9.25979 8.5 9.13261 8.5 9V8.955C9.64 8.74563 10.5 7.83625 10.5 6.75C10.5 5.50938 9.37875 4.5 8 4.5ZM14.5 8C14.5 9.28558 14.1188 10.5423 13.4046 11.6112C12.6903 12.6801 11.6752 13.5132 10.4874 14.0052C9.29973 14.4972 7.99279 14.6259 6.73192 14.3751C5.47104 14.1243 4.31285 13.5052 3.40381 12.5962C2.49477 11.6872 1.8757 10.529 1.6249 9.26809C1.37409 8.00721 1.50282 6.70028 1.99479 5.51256C2.48676 4.32484 3.31988 3.30968 4.3888 2.59545C5.45772 1.88122 6.71442 1.5 8 1.5C9.72335 1.50182 11.3756 2.18722 12.5942 3.40582C13.8128 4.62441 14.4982 6.27665 14.5 8ZM13.5 8C13.5 6.9122 13.1774 5.84883 12.5731 4.94436C11.9687 4.03989 11.1098 3.33494 10.1048 2.91866C9.09977 2.50238 7.9939 2.39346 6.92701 2.60568C5.86011 2.8179 4.8801 3.34172 4.11092 4.11091C3.34173 4.8801 2.8179 5.86011 2.60568 6.927C2.39347 7.9939 2.50238 9.09977 2.91867 10.1048C3.33495 11.1098 4.0399 11.9687 4.94437 12.5731C5.84884 13.1774 6.91221 13.5 8 13.5C9.45819 13.4983 10.8562 12.9184 11.8873 11.8873C12.9184 10.8562 13.4983 9.45818 13.5 8Z" fill="#4B4F54" style="fill:#4B4F54;fill:color(display-p3 0.2941 0.3098 0.3294);fill-opacity:1;"/>
            </svg>
            <p
              class="tooltip min-w-[200px] bg-gray-50 shadow-md rounded-md p-2 text-left font-default text-sm break-normal"
              style=""
              >{{ input.description }}
            </p>
          </div>
        </div>
        <div class="relative" v-if="input.type == 'text' && claim.attributes.length !== 0">
          <core-input
            class="mt-3 w-full items-stretch max-w-full"
            :label="input.name"
            v-model="claim.attributes[index].value"
          />
          <div class="flex-col cursor-pointer flex has-tooltip absolute top-0 -left-6">
            <svg class="mt-0.5 ml-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.75 11.25C8.75 11.3983 8.70602 11.5433 8.6236 11.6667C8.54119 11.79 8.42406 11.8861 8.28701 11.9429C8.14997 11.9997 7.99917 12.0145 7.85368 11.9856C7.7082 11.9566 7.57456 11.8852 7.46967 11.7803C7.36478 11.6754 7.29335 11.5418 7.26441 11.3963C7.23548 11.2508 7.25033 11.1 7.30709 10.963C7.36386 10.8259 7.45999 10.7088 7.58333 10.6264C7.70666 10.544 7.85167 10.5 8 10.5C8.19892 10.5 8.38968 10.579 8.53033 10.7197C8.67098 10.8603 8.75 11.0511 8.75 11.25ZM8 4.5C6.62125 4.5 5.5 5.50938 5.5 6.75V7C5.5 7.13261 5.55268 7.25979 5.64645 7.35355C5.74022 7.44732 5.86739 7.5 6 7.5C6.13261 7.5 6.25979 7.44732 6.35356 7.35355C6.44732 7.25979 6.5 7.13261 6.5 7V6.75C6.5 6.0625 7.17313 5.5 8 5.5C8.82688 5.5 9.5 6.0625 9.5 6.75C9.5 7.4375 8.82688 8 8 8C7.86739 8 7.74022 8.05268 7.64645 8.14645C7.55268 8.24021 7.5 8.36739 7.5 8.5V9C7.5 9.13261 7.55268 9.25979 7.64645 9.35355C7.74022 9.44732 7.86739 9.5 8 9.5C8.13261 9.5 8.25979 9.44732 8.35356 9.35355C8.44732 9.25979 8.5 9.13261 8.5 9V8.955C9.64 8.74563 10.5 7.83625 10.5 6.75C10.5 5.50938 9.37875 4.5 8 4.5ZM14.5 8C14.5 9.28558 14.1188 10.5423 13.4046 11.6112C12.6903 12.6801 11.6752 13.5132 10.4874 14.0052C9.29973 14.4972 7.99279 14.6259 6.73192 14.3751C5.47104 14.1243 4.31285 13.5052 3.40381 12.5962C2.49477 11.6872 1.8757 10.529 1.6249 9.26809C1.37409 8.00721 1.50282 6.70028 1.99479 5.51256C2.48676 4.32484 3.31988 3.30968 4.3888 2.59545C5.45772 1.88122 6.71442 1.5 8 1.5C9.72335 1.50182 11.3756 2.18722 12.5942 3.40582C13.8128 4.62441 14.4982 6.27665 14.5 8ZM13.5 8C13.5 6.9122 13.1774 5.84883 12.5731 4.94436C11.9687 4.03989 11.1098 3.33494 10.1048 2.91866C9.09977 2.50238 7.9939 2.39346 6.92701 2.60568C5.86011 2.8179 4.8801 3.34172 4.11092 4.11091C3.34173 4.8801 2.8179 5.86011 2.60568 6.927C2.39347 7.9939 2.50238 9.09977 2.91867 10.1048C3.33495 11.1098 4.0399 11.9687 4.94437 12.5731C5.84884 13.1774 6.91221 13.5 8 13.5C9.45819 13.4983 10.8562 12.9184 11.8873 11.8873C12.9184 10.8562 13.4983 9.45818 13.5 8Z" fill="#4B4F54" style="fill:#4B4F54;fill:color(display-p3 0.2941 0.3098 0.3294);fill-opacity:1;"/>
            </svg>
            <p
              class="tooltip min-w-[200px] bg-gray-50 shadow-md rounded-md p-2 text-left font-default text-sm break-normal"
              style=""
              >{{ input.description }}
            </p>
          </div>
        </div>
        <div class="relative" v-if="input.type == 'select' && claim.attributes.length !== 0" >
          <core-select
            class="mt-3 w-full items-stretch max-w-full"
            :options="input.options"
            v-model="claim.attributes[index].value"
            :label="input.name"
            labelKey="label"
            valueKey="value"
            style="width: 100%"
            @input="val => claim.attributes[index].value = val"
          />
          <div class="flex-col cursor-pointer flex has-tooltip absolute top-0 -left-6">
            <svg class="mt-0.5 ml-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.75 11.25C8.75 11.3983 8.70602 11.5433 8.6236 11.6667C8.54119 11.79 8.42406 11.8861 8.28701 11.9429C8.14997 11.9997 7.99917 12.0145 7.85368 11.9856C7.7082 11.9566 7.57456 11.8852 7.46967 11.7803C7.36478 11.6754 7.29335 11.5418 7.26441 11.3963C7.23548 11.2508 7.25033 11.1 7.30709 10.963C7.36386 10.8259 7.45999 10.7088 7.58333 10.6264C7.70666 10.544 7.85167 10.5 8 10.5C8.19892 10.5 8.38968 10.579 8.53033 10.7197C8.67098 10.8603 8.75 11.0511 8.75 11.25ZM8 4.5C6.62125 4.5 5.5 5.50938 5.5 6.75V7C5.5 7.13261 5.55268 7.25979 5.64645 7.35355C5.74022 7.44732 5.86739 7.5 6 7.5C6.13261 7.5 6.25979 7.44732 6.35356 7.35355C6.44732 7.25979 6.5 7.13261 6.5 7V6.75C6.5 6.0625 7.17313 5.5 8 5.5C8.82688 5.5 9.5 6.0625 9.5 6.75C9.5 7.4375 8.82688 8 8 8C7.86739 8 7.74022 8.05268 7.64645 8.14645C7.55268 8.24021 7.5 8.36739 7.5 8.5V9C7.5 9.13261 7.55268 9.25979 7.64645 9.35355C7.74022 9.44732 7.86739 9.5 8 9.5C8.13261 9.5 8.25979 9.44732 8.35356 9.35355C8.44732 9.25979 8.5 9.13261 8.5 9V8.955C9.64 8.74563 10.5 7.83625 10.5 6.75C10.5 5.50938 9.37875 4.5 8 4.5ZM14.5 8C14.5 9.28558 14.1188 10.5423 13.4046 11.6112C12.6903 12.6801 11.6752 13.5132 10.4874 14.0052C9.29973 14.4972 7.99279 14.6259 6.73192 14.3751C5.47104 14.1243 4.31285 13.5052 3.40381 12.5962C2.49477 11.6872 1.8757 10.529 1.6249 9.26809C1.37409 8.00721 1.50282 6.70028 1.99479 5.51256C2.48676 4.32484 3.31988 3.30968 4.3888 2.59545C5.45772 1.88122 6.71442 1.5 8 1.5C9.72335 1.50182 11.3756 2.18722 12.5942 3.40582C13.8128 4.62441 14.4982 6.27665 14.5 8ZM13.5 8C13.5 6.9122 13.1774 5.84883 12.5731 4.94436C11.9687 4.03989 11.1098 3.33494 10.1048 2.91866C9.09977 2.50238 7.9939 2.39346 6.92701 2.60568C5.86011 2.8179 4.8801 3.34172 4.11092 4.11091C3.34173 4.8801 2.8179 5.86011 2.60568 6.927C2.39347 7.9939 2.50238 9.09977 2.91867 10.1048C3.33495 11.1098 4.0399 11.9687 4.94437 12.5731C5.84884 13.1774 6.91221 13.5 8 13.5C9.45819 13.4983 10.8562 12.9184 11.8873 11.8873C12.9184 10.8562 13.4983 9.45818 13.5 8Z" fill="#4B4F54" style="fill:#4B4F54;fill:color(display-p3 0.2941 0.3098 0.3294);fill-opacity:1;"/>
            </svg>
            <p
              class="tooltip min-w-[200px] bg-gray-50 shadow-md rounded-md p-2 text-left font-default text-sm break-normal"
              style=""
              >{{ input.description }}
            </p>
          </div>
        </div>
        <div class="w-full py-3 border-b border-[#E5E6E7]" v-if="input.type == 'file' && claim.attributes.length !== 0">
          <div class="flex w-full mb-[10px]">
            <p class="text-[#273F52] text-sm" >{{ input.name }}</p>
            <div class="flex-col cursor-pointer flex has-tooltip relative">
              <svg class="mt-0.5 ml-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.75 11.25C8.75 11.3983 8.70602 11.5433 8.6236 11.6667C8.54119 11.79 8.42406 11.8861 8.28701 11.9429C8.14997 11.9997 7.99917 12.0145 7.85368 11.9856C7.7082 11.9566 7.57456 11.8852 7.46967 11.7803C7.36478 11.6754 7.29335 11.5418 7.26441 11.3963C7.23548 11.2508 7.25033 11.1 7.30709 10.963C7.36386 10.8259 7.45999 10.7088 7.58333 10.6264C7.70666 10.544 7.85167 10.5 8 10.5C8.19892 10.5 8.38968 10.579 8.53033 10.7197C8.67098 10.8603 8.75 11.0511 8.75 11.25ZM8 4.5C6.62125 4.5 5.5 5.50938 5.5 6.75V7C5.5 7.13261 5.55268 7.25979 5.64645 7.35355C5.74022 7.44732 5.86739 7.5 6 7.5C6.13261 7.5 6.25979 7.44732 6.35356 7.35355C6.44732 7.25979 6.5 7.13261 6.5 7V6.75C6.5 6.0625 7.17313 5.5 8 5.5C8.82688 5.5 9.5 6.0625 9.5 6.75C9.5 7.4375 8.82688 8 8 8C7.86739 8 7.74022 8.05268 7.64645 8.14645C7.55268 8.24021 7.5 8.36739 7.5 8.5V9C7.5 9.13261 7.55268 9.25979 7.64645 9.35355C7.74022 9.44732 7.86739 9.5 8 9.5C8.13261 9.5 8.25979 9.44732 8.35356 9.35355C8.44732 9.25979 8.5 9.13261 8.5 9V8.955C9.64 8.74563 10.5 7.83625 10.5 6.75C10.5 5.50938 9.37875 4.5 8 4.5ZM14.5 8C14.5 9.28558 14.1188 10.5423 13.4046 11.6112C12.6903 12.6801 11.6752 13.5132 10.4874 14.0052C9.29973 14.4972 7.99279 14.6259 6.73192 14.3751C5.47104 14.1243 4.31285 13.5052 3.40381 12.5962C2.49477 11.6872 1.8757 10.529 1.6249 9.26809C1.37409 8.00721 1.50282 6.70028 1.99479 5.51256C2.48676 4.32484 3.31988 3.30968 4.3888 2.59545C5.45772 1.88122 6.71442 1.5 8 1.5C9.72335 1.50182 11.3756 2.18722 12.5942 3.40582C13.8128 4.62441 14.4982 6.27665 14.5 8ZM13.5 8C13.5 6.9122 13.1774 5.84883 12.5731 4.94436C11.9687 4.03989 11.1098 3.33494 10.1048 2.91866C9.09977 2.50238 7.9939 2.39346 6.92701 2.60568C5.86011 2.8179 4.8801 3.34172 4.11092 4.11091C3.34173 4.8801 2.8179 5.86011 2.60568 6.927C2.39347 7.9939 2.50238 9.09977 2.91867 10.1048C3.33495 11.1098 4.0399 11.9687 4.94437 12.5731C5.84884 13.1774 6.91221 13.5 8 13.5C9.45819 13.4983 10.8562 12.9184 11.8873 11.8873C12.9184 10.8562 13.4983 9.45818 13.5 8Z" fill="#4B4F54" style="fill:#4B4F54;fill:color(display-p3 0.2941 0.3098 0.3294);fill-opacity:1;"/>
              </svg>
              <p
                class="tooltip min-w-[200px] bg-gray-50 shadow-md rounded-md p-2 text-left font-default text-sm break-normal"
                style=""
                >{{ input.description }}
              </p>
            </div>
            <input class="hidden" :ref="input.key" type="file" @change="val => addFile(val, input.key, index, false)" accept="image/*,.pdf,.docx,.xlsx">
            <p class="ml-auto text-[#0080FF] text-xs mt-0.5 cursor-pointer" @click="$refs[input.key][0].click()">{{ $t("upload_entity", { entity: $t("documents").toLowerCase() }) }}</p>
          </div>
          <div
            v-if="claim.attributes[index].fileName"
          >
            <div class="flex mb-[10px]">
              <p class="text-[#737C89] text-sm ">{{ claim.attributes[index].fileName }}</p>
              <svg class="ml-auto cursor-pointer" @click="removeFile(index, 0, false)" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.7729 16.977C17.8786 17.0827 17.938 17.226 17.938 17.3754C17.938 17.5249 17.8786 17.6682 17.7729 17.7739C17.6673 17.8795 17.524 17.9389 17.3745 17.9389C17.2251 17.9389 17.0817 17.8795 16.9761 17.7739L14 14.7968L11.0229 17.7729C10.9173 17.8786 10.774 17.938 10.6245 17.938C10.4751 17.938 10.3317 17.8786 10.2261 17.7729C10.1204 17.6673 10.061 17.5239 10.061 17.3745C10.061 17.225 10.1204 17.0817 10.2261 16.9761L13.2031 14L10.227 11.0229C10.1213 10.9173 10.062 10.7739 10.062 10.6245C10.062 10.475 10.1213 10.3317 10.227 10.2261C10.3327 10.1204 10.476 10.061 10.6254 10.061C10.7749 10.061 10.9182 10.1204 11.0239 10.2261L14 13.2031L16.977 10.2256C17.0827 10.1199 17.226 10.0605 17.3754 10.0605C17.5249 10.0605 17.6682 10.1199 17.7739 10.2256C17.8796 10.3313 17.9389 10.4746 17.9389 10.624C17.9389 10.7735 17.8796 10.9168 17.7739 11.0225L14.7969 14L17.7729 16.977Z" fill="#4B4F54" style="fill:#4B4F54;fill:color(display-p3 0.2941 0.3098 0.3294);fill-opacity:1;"/>
              </svg>
            </div>
          </div>
        </div>
        <div class="w-full py-3 border-b border-[#E5E6E7]" v-if="input.type == 'file[]' && claim.attributes.length !== 0">
          <div class="flex w-full mb-[10px]">
            <p class="text-[#273F52] text-sm" >{{ input.name }}</p>
            <div class="flex-col cursor-pointer flex has-tooltip relative">
              <svg class="mt-0.5 ml-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.75 11.25C8.75 11.3983 8.70602 11.5433 8.6236 11.6667C8.54119 11.79 8.42406 11.8861 8.28701 11.9429C8.14997 11.9997 7.99917 12.0145 7.85368 11.9856C7.7082 11.9566 7.57456 11.8852 7.46967 11.7803C7.36478 11.6754 7.29335 11.5418 7.26441 11.3963C7.23548 11.2508 7.25033 11.1 7.30709 10.963C7.36386 10.8259 7.45999 10.7088 7.58333 10.6264C7.70666 10.544 7.85167 10.5 8 10.5C8.19892 10.5 8.38968 10.579 8.53033 10.7197C8.67098 10.8603 8.75 11.0511 8.75 11.25ZM8 4.5C6.62125 4.5 5.5 5.50938 5.5 6.75V7C5.5 7.13261 5.55268 7.25979 5.64645 7.35355C5.74022 7.44732 5.86739 7.5 6 7.5C6.13261 7.5 6.25979 7.44732 6.35356 7.35355C6.44732 7.25979 6.5 7.13261 6.5 7V6.75C6.5 6.0625 7.17313 5.5 8 5.5C8.82688 5.5 9.5 6.0625 9.5 6.75C9.5 7.4375 8.82688 8 8 8C7.86739 8 7.74022 8.05268 7.64645 8.14645C7.55268 8.24021 7.5 8.36739 7.5 8.5V9C7.5 9.13261 7.55268 9.25979 7.64645 9.35355C7.74022 9.44732 7.86739 9.5 8 9.5C8.13261 9.5 8.25979 9.44732 8.35356 9.35355C8.44732 9.25979 8.5 9.13261 8.5 9V8.955C9.64 8.74563 10.5 7.83625 10.5 6.75C10.5 5.50938 9.37875 4.5 8 4.5ZM14.5 8C14.5 9.28558 14.1188 10.5423 13.4046 11.6112C12.6903 12.6801 11.6752 13.5132 10.4874 14.0052C9.29973 14.4972 7.99279 14.6259 6.73192 14.3751C5.47104 14.1243 4.31285 13.5052 3.40381 12.5962C2.49477 11.6872 1.8757 10.529 1.6249 9.26809C1.37409 8.00721 1.50282 6.70028 1.99479 5.51256C2.48676 4.32484 3.31988 3.30968 4.3888 2.59545C5.45772 1.88122 6.71442 1.5 8 1.5C9.72335 1.50182 11.3756 2.18722 12.5942 3.40582C13.8128 4.62441 14.4982 6.27665 14.5 8ZM13.5 8C13.5 6.9122 13.1774 5.84883 12.5731 4.94436C11.9687 4.03989 11.1098 3.33494 10.1048 2.91866C9.09977 2.50238 7.9939 2.39346 6.92701 2.60568C5.86011 2.8179 4.8801 3.34172 4.11092 4.11091C3.34173 4.8801 2.8179 5.86011 2.60568 6.927C2.39347 7.9939 2.50238 9.09977 2.91867 10.1048C3.33495 11.1098 4.0399 11.9687 4.94437 12.5731C5.84884 13.1774 6.91221 13.5 8 13.5C9.45819 13.4983 10.8562 12.9184 11.8873 11.8873C12.9184 10.8562 13.4983 9.45818 13.5 8Z" fill="#4B4F54" style="fill:#4B4F54;fill:color(display-p3 0.2941 0.3098 0.3294);fill-opacity:1;"/>
              </svg>
              <p
                class="tooltip bg-gray-50 shadow-md rounded-md p-2 text-left font-default text-sm break-normal"
                style=""
                >{{ input.description }}
              </p>
            </div>
            <input class="hidden" :ref="input.key" type="file" @change="val => addFile(val, input.key, index, true)" accept="image/*,.pdf,.docx,.xlsx" :multiple="true">
            <p class="ml-auto text-[#0080FF] text-xs mt-0.5 cursor-pointer" @click="$refs[input.key][0].click()">{{ $t("upload_entity", { entity: $t("documents").toLowerCase() }) }}</p>
          </div>
          <div
            v-if="claim.attributes[index].fileNames.length !== 0"
          >
            <div v-for="file, index2 in claim.attributes[index].value" :key="file + '_' + index2" class="flex mb-[10px]">
                <p class="text-[#737C89] text-sm ">{{ claim.attributes[index].fileNames[index2] }}</p>
              <svg class="ml-auto cursor-pointer" @click="removeFile(index, index2, true)" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.7729 16.977C17.8786 17.0827 17.938 17.226 17.938 17.3754C17.938 17.5249 17.8786 17.6682 17.7729 17.7739C17.6673 17.8795 17.524 17.9389 17.3745 17.9389C17.2251 17.9389 17.0817 17.8795 16.9761 17.7739L14 14.7968L11.0229 17.7729C10.9173 17.8786 10.774 17.938 10.6245 17.938C10.4751 17.938 10.3317 17.8786 10.2261 17.7729C10.1204 17.6673 10.061 17.5239 10.061 17.3745C10.061 17.225 10.1204 17.0817 10.2261 16.9761L13.2031 14L10.227 11.0229C10.1213 10.9173 10.062 10.7739 10.062 10.6245C10.062 10.475 10.1213 10.3317 10.227 10.2261C10.3327 10.1204 10.476 10.061 10.6254 10.061C10.7749 10.061 10.9182 10.1204 11.0239 10.2261L14 13.2031L16.977 10.2256C17.0827 10.1199 17.226 10.0605 17.3754 10.0605C17.5249 10.0605 17.6682 10.1199 17.7739 10.2256C17.8796 10.3313 17.9389 10.4746 17.9389 10.624C17.9389 10.7735 17.8796 10.9168 17.7739 11.0225L14.7969 14L17.7729 16.977Z" fill="#4B4F54" style="fill:#4B4F54;fill:color(display-p3 0.2941 0.3098 0.3294);fill-opacity:1;"/>
              </svg>
            </div>
          </div>
        </div>
        <div class="w-full py-3 border-b border-[#E5E6E7]" v-if="input.type == 'dor' && claim.attributes.length !== 0">
          <div class="flex w-full mb-[10px]">
            <p class="text-[#273F52] text-sm" >{{ input.name }}</p>
            <div class="flex-col cursor-pointer flex has-tooltip relative">
              <svg class="mt-0.5 ml-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.75 11.25C8.75 11.3983 8.70602 11.5433 8.6236 11.6667C8.54119 11.79 8.42406 11.8861 8.28701 11.9429C8.14997 11.9997 7.99917 12.0145 7.85368 11.9856C7.7082 11.9566 7.57456 11.8852 7.46967 11.7803C7.36478 11.6754 7.29335 11.5418 7.26441 11.3963C7.23548 11.2508 7.25033 11.1 7.30709 10.963C7.36386 10.8259 7.45999 10.7088 7.58333 10.6264C7.70666 10.544 7.85167 10.5 8 10.5C8.19892 10.5 8.38968 10.579 8.53033 10.7197C8.67098 10.8603 8.75 11.0511 8.75 11.25ZM8 4.5C6.62125 4.5 5.5 5.50938 5.5 6.75V7C5.5 7.13261 5.55268 7.25979 5.64645 7.35355C5.74022 7.44732 5.86739 7.5 6 7.5C6.13261 7.5 6.25979 7.44732 6.35356 7.35355C6.44732 7.25979 6.5 7.13261 6.5 7V6.75C6.5 6.0625 7.17313 5.5 8 5.5C8.82688 5.5 9.5 6.0625 9.5 6.75C9.5 7.4375 8.82688 8 8 8C7.86739 8 7.74022 8.05268 7.64645 8.14645C7.55268 8.24021 7.5 8.36739 7.5 8.5V9C7.5 9.13261 7.55268 9.25979 7.64645 9.35355C7.74022 9.44732 7.86739 9.5 8 9.5C8.13261 9.5 8.25979 9.44732 8.35356 9.35355C8.44732 9.25979 8.5 9.13261 8.5 9V8.955C9.64 8.74563 10.5 7.83625 10.5 6.75C10.5 5.50938 9.37875 4.5 8 4.5ZM14.5 8C14.5 9.28558 14.1188 10.5423 13.4046 11.6112C12.6903 12.6801 11.6752 13.5132 10.4874 14.0052C9.29973 14.4972 7.99279 14.6259 6.73192 14.3751C5.47104 14.1243 4.31285 13.5052 3.40381 12.5962C2.49477 11.6872 1.8757 10.529 1.6249 9.26809C1.37409 8.00721 1.50282 6.70028 1.99479 5.51256C2.48676 4.32484 3.31988 3.30968 4.3888 2.59545C5.45772 1.88122 6.71442 1.5 8 1.5C9.72335 1.50182 11.3756 2.18722 12.5942 3.40582C13.8128 4.62441 14.4982 6.27665 14.5 8ZM13.5 8C13.5 6.9122 13.1774 5.84883 12.5731 4.94436C11.9687 4.03989 11.1098 3.33494 10.1048 2.91866C9.09977 2.50238 7.9939 2.39346 6.92701 2.60568C5.86011 2.8179 4.8801 3.34172 4.11092 4.11091C3.34173 4.8801 2.8179 5.86011 2.60568 6.927C2.39347 7.9939 2.50238 9.09977 2.91867 10.1048C3.33495 11.1098 4.0399 11.9687 4.94437 12.5731C5.84884 13.1774 6.91221 13.5 8 13.5C9.45819 13.4983 10.8562 12.9184 11.8873 11.8873C12.9184 10.8562 13.4983 9.45818 13.5 8Z" fill="#4B4F54" style="fill:#4B4F54;fill:color(display-p3 0.2941 0.3098 0.3294);fill-opacity:1;"/>
              </svg>
              <p
                class="tooltip min-w-[200px] bg-gray-50 shadow-md rounded-md p-2 text-left font-default text-sm break-normal"
                style=""
                >{{ input.description }}
              </p>
            </div>
            <input class="hidden" :ref="input.key" type="file" @change="val => addFile(val, input.key, index, false)" accept="image/*,.pdf,.docx,.xlsx">
            <p class="ml-auto text-[#0080FF] text-xs mt-0.5 cursor-pointer" @click="$refs[input.key][0].click()">{{ $t("upload_entity", { entity: $t("documents").toLowerCase() }) }}</p>
          </div>
          <div
            v-if="claim.attributes[index].fileName"
          >
            <div class="flex mb-[10px]">
              <p class="text-[#737C89] text-sm ">{{ claim.attributes[index].fileName }}</p>
              <svg class="ml-auto cursor-pointer" @click="removeFile(index, 0, false)" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.7729 16.977C17.8786 17.0827 17.938 17.226 17.938 17.3754C17.938 17.5249 17.8786 17.6682 17.7729 17.7739C17.6673 17.8795 17.524 17.9389 17.3745 17.9389C17.2251 17.9389 17.0817 17.8795 16.9761 17.7739L14 14.7968L11.0229 17.7729C10.9173 17.8786 10.774 17.938 10.6245 17.938C10.4751 17.938 10.3317 17.8786 10.2261 17.7729C10.1204 17.6673 10.061 17.5239 10.061 17.3745C10.061 17.225 10.1204 17.0817 10.2261 16.9761L13.2031 14L10.227 11.0229C10.1213 10.9173 10.062 10.7739 10.062 10.6245C10.062 10.475 10.1213 10.3317 10.227 10.2261C10.3327 10.1204 10.476 10.061 10.6254 10.061C10.7749 10.061 10.9182 10.1204 11.0239 10.2261L14 13.2031L16.977 10.2256C17.0827 10.1199 17.226 10.0605 17.3754 10.0605C17.5249 10.0605 17.6682 10.1199 17.7739 10.2256C17.8796 10.3313 17.9389 10.4746 17.9389 10.624C17.9389 10.7735 17.8796 10.9168 17.7739 11.0225L14.7969 14L17.7729 16.977Z" fill="#4B4F54" style="fill:#4B4F54;fill:color(display-p3 0.2941 0.3098 0.3294);fill-opacity:1;"/>
              </svg>
            </div>
          </div>
          <div class="p-4 flex gap-2 rounded-md bg-[#F6F6F7]">
            <div class="w-16 h-16">
              <svg class="" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="Info">
                  <path id="Vector" d="M6.75 5.25C6.75 5.05222 6.80865 4.85888 6.91853 4.69443C7.02841 4.52998 7.18459 4.40181 7.36732 4.32612C7.55005 4.25043 7.75111 4.23063 7.94509 4.26921C8.13907 4.3078 8.31726 4.40304 8.45711 4.54289C8.59696 4.68275 8.6922 4.86093 8.73079 5.05491C8.76937 5.24889 8.74957 5.44996 8.67388 5.63268C8.5982 5.81541 8.47002 5.97159 8.30557 6.08147C8.14112 6.19135 7.94778 6.25 7.75 6.25C7.48479 6.25 7.23043 6.14464 7.0429 5.95711C6.85536 5.76957 6.75 5.51522 6.75 5.25ZM14.75 8C14.75 9.33502 14.3541 10.6401 13.6124 11.7501C12.8707 12.8601 11.8165 13.7253 10.5831 14.2362C9.34971 14.7471 7.99252 14.8808 6.68314 14.6203C5.37377 14.3598 4.17104 13.717 3.22703 12.773C2.28303 11.829 1.64015 10.6262 1.3797 9.31686C1.11925 8.00749 1.25292 6.65029 1.76382 5.41689C2.27471 4.18349 3.13987 3.12928 4.2499 2.38758C5.35994 1.64588 6.66498 1.25 8 1.25C9.78961 1.25199 11.5053 1.96378 12.7708 3.22922C14.0362 4.49466 14.748 6.2104 14.75 8ZM13.25 8C13.25 6.96165 12.9421 5.94661 12.3652 5.08326C11.7883 4.2199 10.9684 3.54699 10.0091 3.14963C9.04978 2.75227 7.99418 2.6483 6.97578 2.85088C5.95738 3.05345 5.02192 3.55346 4.28769 4.28769C3.55347 5.02191 3.05345 5.95738 2.85088 6.97578C2.64831 7.99418 2.75228 9.04978 3.14964 10.0091C3.547 10.9684 4.2199 11.7883 5.08326 12.3652C5.94662 12.9421 6.96165 13.25 8 13.25C9.39193 13.2485 10.7264 12.6949 11.7107 11.7107C12.6949 10.7264 13.2485 9.39193 13.25 8ZM8.75 10.2925V8.25C8.75 7.91848 8.61831 7.60054 8.38389 7.36612C8.14947 7.1317 7.83152 7 7.5 7C7.32288 6.99974 7.15139 7.06217 7.01588 7.17623C6.88038 7.2903 6.78962 7.44864 6.75968 7.62321C6.72974 7.79778 6.76254 7.97731 6.85229 8.13001C6.94203 8.28271 7.08292 8.39872 7.25 8.4575V10.5C7.25 10.8315 7.3817 11.1495 7.61612 11.3839C7.85054 11.6183 8.16848 11.75 8.5 11.75C8.67712 11.7503 8.84862 11.6878 8.98412 11.5738C9.11962 11.4597 9.21038 11.3014 9.24032 11.1268C9.27027 10.9522 9.23746 10.7727 9.14772 10.62C9.05798 10.4673 8.91709 10.3513 8.75 10.2925Z" fill="#39414B" style="fill:#39414B;fill:color(display-p3 0.2235 0.2549 0.2941);fill-opacity:1;"/>
                </g>
              </svg>
            </div>
            <div class="">
              <p class="text-[#34414D] text-xs break-normal">{{ $t('dor_info') }}</p>
              <a :href="input.options.link" target="_blank" rel="noopener noreferrer">
                <p class="text-xs text-blue-500 underline">{{ $t("download_entity", { entity: $t("template").toLowerCase() }) }}</p>
              </a>
            </div>
          </div>
        </div>
        <div class="w-full py-3 border-b border-[#E5E6E7]" v-if="input.type == 'file_with_pdf' && claim.attributes.length !== 0">
          <div class="flex w-full mb-[10px]">
            <p class="text-[#273F52] text-sm" >{{ input.name }}</p>
            <input class="hidden" :ref="input.key" type="file" @change="val => addFile(val, input.key, index, false)" accept="image/*,.pdf,.docx,.xlsx">
            <p class="ml-auto text-[#0080FF] text-xs mt-0.5 cursor-pointer" @click="$refs[input.key][0].click()">{{ $t("upload_entity", { entity: $t("documents").toLowerCase() }) }}</p>
          </div>
          <div
            v-if="claim.attributes[index].fileName"
          >
            <div class="flex mb-[10px]">
              <p class="text-[#737C89] text-sm ">{{ claim.attributes[index].fileName }}</p>
              <svg class="ml-auto cursor-pointer" @click="removeFile(index, 0, false)" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.7729 16.977C17.8786 17.0827 17.938 17.226 17.938 17.3754C17.938 17.5249 17.8786 17.6682 17.7729 17.7739C17.6673 17.8795 17.524 17.9389 17.3745 17.9389C17.2251 17.9389 17.0817 17.8795 16.9761 17.7739L14 14.7968L11.0229 17.7729C10.9173 17.8786 10.774 17.938 10.6245 17.938C10.4751 17.938 10.3317 17.8786 10.2261 17.7729C10.1204 17.6673 10.061 17.5239 10.061 17.3745C10.061 17.225 10.1204 17.0817 10.2261 16.9761L13.2031 14L10.227 11.0229C10.1213 10.9173 10.062 10.7739 10.062 10.6245C10.062 10.475 10.1213 10.3317 10.227 10.2261C10.3327 10.1204 10.476 10.061 10.6254 10.061C10.7749 10.061 10.9182 10.1204 11.0239 10.2261L14 13.2031L16.977 10.2256C17.0827 10.1199 17.226 10.0605 17.3754 10.0605C17.5249 10.0605 17.6682 10.1199 17.7739 10.2256C17.8796 10.3313 17.9389 10.4746 17.9389 10.624C17.9389 10.7735 17.8796 10.9168 17.7739 11.0225L14.7969 14L17.7729 16.977Z" fill="#4B4F54" style="fill:#4B4F54;fill:color(display-p3 0.2941 0.3098 0.3294);fill-opacity:1;"/>
              </svg>
            </div>
          </div>
          <div class="p-4 flex gap-2 rounded-md bg-[#F6F6F7]">
            <div class="w-16 h-16">
              <svg class="" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="Info">
                  <path id="Vector" d="M6.75 5.25C6.75 5.05222 6.80865 4.85888 6.91853 4.69443C7.02841 4.52998 7.18459 4.40181 7.36732 4.32612C7.55005 4.25043 7.75111 4.23063 7.94509 4.26921C8.13907 4.3078 8.31726 4.40304 8.45711 4.54289C8.59696 4.68275 8.6922 4.86093 8.73079 5.05491C8.76937 5.24889 8.74957 5.44996 8.67388 5.63268C8.5982 5.81541 8.47002 5.97159 8.30557 6.08147C8.14112 6.19135 7.94778 6.25 7.75 6.25C7.48479 6.25 7.23043 6.14464 7.0429 5.95711C6.85536 5.76957 6.75 5.51522 6.75 5.25ZM14.75 8C14.75 9.33502 14.3541 10.6401 13.6124 11.7501C12.8707 12.8601 11.8165 13.7253 10.5831 14.2362C9.34971 14.7471 7.99252 14.8808 6.68314 14.6203C5.37377 14.3598 4.17104 13.717 3.22703 12.773C2.28303 11.829 1.64015 10.6262 1.3797 9.31686C1.11925 8.00749 1.25292 6.65029 1.76382 5.41689C2.27471 4.18349 3.13987 3.12928 4.2499 2.38758C5.35994 1.64588 6.66498 1.25 8 1.25C9.78961 1.25199 11.5053 1.96378 12.7708 3.22922C14.0362 4.49466 14.748 6.2104 14.75 8ZM13.25 8C13.25 6.96165 12.9421 5.94661 12.3652 5.08326C11.7883 4.2199 10.9684 3.54699 10.0091 3.14963C9.04978 2.75227 7.99418 2.6483 6.97578 2.85088C5.95738 3.05345 5.02192 3.55346 4.28769 4.28769C3.55347 5.02191 3.05345 5.95738 2.85088 6.97578C2.64831 7.99418 2.75228 9.04978 3.14964 10.0091C3.547 10.9684 4.2199 11.7883 5.08326 12.3652C5.94662 12.9421 6.96165 13.25 8 13.25C9.39193 13.2485 10.7264 12.6949 11.7107 11.7107C12.6949 10.7264 13.2485 9.39193 13.25 8ZM8.75 10.2925V8.25C8.75 7.91848 8.61831 7.60054 8.38389 7.36612C8.14947 7.1317 7.83152 7 7.5 7C7.32288 6.99974 7.15139 7.06217 7.01588 7.17623C6.88038 7.2903 6.78962 7.44864 6.75968 7.62321C6.72974 7.79778 6.76254 7.97731 6.85229 8.13001C6.94203 8.28271 7.08292 8.39872 7.25 8.4575V10.5C7.25 10.8315 7.3817 11.1495 7.61612 11.3839C7.85054 11.6183 8.16848 11.75 8.5 11.75C8.67712 11.7503 8.84862 11.6878 8.98412 11.5738C9.11962 11.4597 9.21038 11.3014 9.24032 11.1268C9.27027 10.9522 9.23746 10.7727 9.14772 10.62C9.05798 10.4673 8.91709 10.3513 8.75 10.2925Z" fill="#39414B" style="fill:#39414B;fill:color(display-p3 0.2235 0.2549 0.2941);fill-opacity:1;"/>
                </g>
              </svg>
            </div>
            <div class="">
              <p class="text-[#34414D] text-xs break-normal">{{ input.description }}</p>
              <a :href="input.options.link" target="_blank" rel="noopener noreferrer">
                <p class="text-xs text-blue-500 underline">{{ $t("download_entity", { entity: $t("template").toLowerCase() }) }}</p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <core-input
      class="mt-3 w-full items-stretch max-w-full"
      inputType="textarea"
      placeholder=""
      :label="$t('Besked til kundeservice')"
      @change="val => claim.message = val"
    />
  </div>
  </div>
  <div
      slot="footer"
      style="width: 100%"
      class="dialog-footer flex justify-end mt-4"
    >
      <slot name="buttons-prefix" />
      <core-button
        type="coolrunner"
        @click="createClaim()"
        class="ml-2"
        :disabled="formOkay"
        >{{ $t("create_claim") }}
      </core-button>
    </div>
  </core-dialog>
</template>

<script>
import { URL_PREFIX } from "@/utils/constants";
import _ from "lodash";
import Loader from "@/mixins/Loader";
import FormData from "@/mixins/FormData";
import Uploader from "@/mixins/S3Upload";
export default {
  mixins: [Loader, FormData, Uploader],
  name: "create_claim",
  props: {
    shipment: {
      type: [Object, Array],
      default: () => {}
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    dor_link: "",
    has_dor: false,
    dhlError: false,
    costPriceWarning: false,
    invoiceWarning: false,
    addressChangeRule: null,
    noCallBack: false,
    callBackMessage: null,
    imageWarning: false,
    contentWarning: false,
    typeError: false,
    noAddressChange: false,
    package_number: null,
    packageError: false,
    dataUrls: [],
    uploading: false,
    deadline: false,
    ticketExistsId: null,
    inputs:[],
    types: [],
    defaultLoaderTarget: "#return_shipments_dialog__container",
    claim: {
      shipment_id: null,
      type: null,
      from_name: null,
      from_email: null,
      cc: null,
      message: null,
      attributes: []
    },
    tabindex: 1,
    options: [],
    selectedType: {name: 'Vælg type'},
    open: false,
  }),
  watch: {
    shipment: function(newVal, oldVal) {
      if (newVal && newVal !== oldVal  ) {
        this.shipment = newVal;
        this.claim.package_number = newVal.package_number;
        this.checkPackageOptions(newVal.package_number)
      }
    }
  },
  mounted() {
    this.$emit("input", this.selectedType);
  },
  computed: {
    URL_PREFIX: () => URL_PREFIX,
    checkPackageNumber: function () {
      if (!this.package_number) {
        return true
      } else {
        return false
      }
    },
    formOkay: function() {
      if (
        this.claim.message &&
        this.claim.type &&
        this.claim.shipment_id
        ) {
        if (this.$_.some(this.claim.attributes, value => value.value == null || value.value.length == 0)) {
          return true
        } else {
          return false
        }
      }
      return (
        true
      );
    }
  },
  methods: {
    getNumberOfItems: function (items) {
      let numberOfItems = 0
      _.forEach(items, function(item) {
        numberOfItems = numberOfItems + item.qty
      })
      return numberOfItems
    },
    getPackage: function () {
      this.ticketExistsId = null
      this.loading = true
      this.packageError = false
      this.$get(`shipments/by-package-number/${this.package_number}`).then(r => {
        if (r == "OK") {
          this.packageError = true
          this.loading = false
        } else {
          this.shipment = r;
          this.loading = false
        }
      })
      .catch(e => {
        this.packageError = true
        this.loading = false
      });
    },
    checkPackageOptions: function (packageNumber) {
      this.loading = true
      this.deadline = false
      this.$get(`/ticket/create/${packageNumber}`).then(r => {
          if (r.ticket_id) {
            const id = Date.now();
            this.$notification({
              id: id,
              title: this.$t("claim_exists"),
              text: "Id: " + r.ticket_id,
              duration: 5000
            });
            this.loading = false
            this.shipment = null
            this.ticketExistsId = r.shipment_id
          } else {
            this.options = r.data
            this.deadline = r.deadline
            this.loading = false
          }
        }).catch(e => {
          this.loading = false
        });
    },
    goToShipment: function () {
      this.$router.push({
        name: 'labels_details',
        params: { id: this.ticketExistsId }
      });
    },
    close: function() {
      this.$emit("update:visible", false);
      this.claim = {
        shipment_id: null,
        type: null,
        from_name: null,
        from_email: null,
        cc: null,
        message: null,
        attributes: []
      };
      this.inputs = [];
      this.dataUrls = [];
      this.has_dor = false;
      this.dor_link = "";
      this.costPriceWarning = false
      this.invoiceWarning = false
      this.imageWarning = false
      this.contentWarning = false
      this.dhlError = false
      this.typeError = false
      this.noAddressChange = false
      this.addressChangeRule = null
      this.noCallBack = false,
      this.callBackMessage = null
      this.shipment = null
      this.selectedType = {name: 'Vælg type'};
    },
    createClaim: function() {
      this.claim.from_name = this.$store.state.accountRes[0].user.name;
      const id = Date.now();
      this.$notification({
        id: id,
        title: this.$t("generating_claim"),
        text: this.$t("generating_claim_text"), 
        duration: -1
      });

      this.$upload(
        `/ticket/create`,
        this.claim,
        {
          failSilently: true
        }
      )
        .then(response => {
          this.$notification.close(id);
          this.$notification({
            title: this.$t("claim_generated"),
            text: response.message,
            duration: 5000
          });
          this.close()
        })
        .catch(e => {
          const errors =
            e.response.data.errors ?? e.response.data.message;
          this.$notification.close(id);
          this.$notification({
            title: this.$t("claim_failed"),
            text: errors,
            type: "error",
            duration: 2500
          });
        });
    },
    selectType: function (option) {
      this.claim.attributes = [];
      this.selectedType = option;
      this.claim.type = option.state
      this.claim.shipment_id = this.shipment.id
      this.open = false;
      this.$emit('input', option);
      option.attributes.forEach((attribute) => {
        if (attribute.type == 'file' ||  attribute.type == 'dor') {
          this.claim.attributes.push(
            {
              key: attribute.key,
              value: null,
              type: attribute.type,
              type_attribute_id: attribute.id,
              fileName: null
            }
          )
        } else if (attribute.type == 'file[]') {
          this.claim.attributes.push(
            {
              key: attribute.key,
              value: [],
              type: attribute.type,
              type_attribute_id: attribute.id,
              fileNames: []
            }
          )
        } else {
          this.claim.attributes.push(
            {
              key: attribute.key,
              value: null,
              type: attribute.type,
              type_attribute_id: attribute.id
            }
          )
        }
      });
      this.inputs = option.attributes
    },
    addFile: function(files, key, index, multiple) {
      this.loading = true
      if (multiple) {
      _.forEach(files.target.files, (file, key) => {
        this.uploadImage(file, key, this.shipment.id).then((value) => {
          this.loading = false;
          this.claim.attributes[index].value.push(value.Key)
          this.claim.attributes[index].fileNames.push(file.name)
        });
      })
      } else {
        this.uploadImage(files.target.files[0], key, this.shipment.id).then((value) => {
          this.loading = false;
            this.claim.attributes[index].value = value.Key
            this.$set(this.claim.attributes[index], 'fileName', files.target.files[0].name)
        });
      }
    },
    removeFile: function (index, index2, multiple) {
      if (multiple) {
        this.claim.attributes[index].value.splice(index2, 1);
        this.claim.attributes[index].fileNames.splice(index2, 1);
      } else {
        this.claim.attributes[index].value = null
        this.claim.attributes[index].fileName = null
      }
      
    },
    openDOR: function() {
      window.open(
        `${URL_PREFIX}/business-panel/documents/dor/${this.claim.package_number}/shipment?access_token=${this.$store.state.auth.access_token}&account_id=${this.$store.state.account_id}`
      );
    },
    updateDescription: function(description, i) {
      const index = i;
      const proofUrls = this.claim.proof_urls || [];
      const newProofs = [...proofUrls];
      newProofs.splice(index, 1, { ...newProofs[index], description });

      this.claim = {
        ...this.claim,
        proof_urls: newProofs
      };
    },
    setImageData: function(index) {
      let array = this.dataUrls;

      _.forEach(this.claim.proof_urls, function(file) {
        if (_.isString(file.base64)) {
          array.push(`data:${this.mimeType};base64,${file}`);
        }

        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          if (_.includes(array, e.target.result)) {
            return;
          } else {
            array.push(e.target.result);
          }
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(file.base64);
      });
    }
  }
};
</script>

<style lang="scss">
@tailwind base;
@tailwind components;
@tailwind utilities;

.tooltip {
  @apply opacity-0 absolute left-2 top-4 transition duration-300 ease-in-out pointer-events-none break-normal max-w-sm;
}

.has-tooltip:hover .tooltip {
  @apply opacity-100 z-50 transition duration-300 ease-in-out pointer-events-none;
}
.el-dialog__wrapper .el-dialog__body {
  display: block;
}
.el-dialog {
  display: flex;
  flex-direction: column;
}
.el-dialog__body {
  margin-bottom: auto;
}
.custom-select {
  position: relative;
  width: 100%;
  text-align: left;
  outline: none;
  height: 56px;
  line-height: 47px;
}

.custom-select .selected {
  border-radius: 6px;
  border: 1px solid #D1D5DB;
  color: #000;
  font-size: 16px;
  padding: 4px 12px;
  cursor: pointer;
  user-select: none;
  height: 56px;
}

.custom-select .selected.open {
  border: 1px solid #3B82F6;
  border-radius: 6px;
}

.custom-select .selected:after {
  position: absolute;
  content: "";
  top: 8px;
  right: 30px;
  width: 0;
  height: 0;
  content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 14 14' fill='none'%3E%3Cpath d='M10.1479 4.89793L6.39795 8.64793C6.34569 8.70037 6.28359 8.74198 6.21522 8.77037C6.14685 8.79876 6.07354 8.81337 5.99951 8.81337C5.92548 8.81337 5.85217 8.79876 5.7838 8.77037C5.71543 8.74198 5.65333 8.70037 5.60107 8.64793L1.85107 4.89793C1.7454 4.79226 1.68604 4.64893 1.68604 4.49949C1.68604 4.35005 1.7454 4.20673 1.85107 4.10105C1.95675 3.99538 2.10007 3.93602 2.24951 3.93602C2.39895 3.93602 2.54228 3.99538 2.64795 4.10105L5.99998 7.45308L9.35201 4.10059C9.45768 3.99491 9.601 3.93555 9.75045 3.93555C9.89989 3.93555 10.0432 3.99491 10.1489 4.10059C10.2546 4.20626 10.3139 4.34958 10.3139 4.49902C10.3139 4.64847 10.2546 4.79179 10.1489 4.89746L10.1479 4.89793Z' fill='%23D1D5DB' style='fill:%23D1D5DB;fill-opacity:1;'/%3E%3C/svg%3E");
}

.custom-select .items {
  color: #000;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #D1D5DB;
  position: absolute;
  background-color: #fff;
  top: 58px;
  left: 0;
  right: 0;
  z-index: 1;
}

.custom-select .items div {
  color: #000;
  padding-left: 1em;
  cursor: pointer;
  user-select: none;
}

.custom-select .items div:hover {
  background-color: #F5F7FB;
}

.selectHide {
  display: none;
}
</style>
